import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";

import Tag from "@meetyoo/components/src/components/Tag";
import TableConfigurator from "../TableLayout/TableConfigurator";

const useStyle = makeStyles(theme => ({
  tag: {
    cursor: "pointer",
    paddingRight: theme.spacing(0.5),
    paddingTop: theme.spacing(0.5),
  },
  inline: {
    display: "flex",
    maxWidth: "100%",
    flexWrap: "wrap",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContainer: {
    width: "750px",
    backgroundColor: "#eee",
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const TableSelectModalComponent = ({ onClick, open, onClose, ownTableLayout, translate }) => {
  const classes = useStyle();
  return (
    <Modal
      open={open}
      className={classes.modal}
      onClose={() => {
        onClose();
      }}
    >
      <Fade in={open}>
        <div className={classes.modalContainer}>
          <div className={classes.inline}>
            {Object.keys(TableConfigurator).map(
              item =>
                !["title", "customer", "lastContactAt", "owner", "webcastID", "orderID"].includes(item) && (
                  <div aria-hidden key={item} role="button" className={classes.tag} onClick={() => onClick(item)}>
                    <Tag
                      text={translate[TableConfigurator[item].label]}
                      color={ownTableLayout.indexOf(item) !== -1 ? "rgb(0, 217, 0)" : "grey"}
                      size="big"
                    />
                  </div>
                )
            )}
          </div>
        </div>
      </Fade>
    </Modal>
  );
};
TableSelectModalComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  ownTableLayout: PropTypes.array.isRequired,
  translate: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  translate: state.ui.translate,
});

const TableSelectModal = connect(mapStateToProps)(TableSelectModalComponent);

export default TableSelectModal;
